export class archivedUrls {
    ACCESS_LINK_URL = "ssr/v2/archived-return/{taxReturnId}/access-link";
    ARCHIVED_RETURNS_URL = "ssr/v2/archived-return/all[?ClientId][&ClientName][&TaxYear][&ERO][&SignatureStatus][&EngagementType][&DeliveredAfter][&PageSize][&PageNumber][&SortBy][&SortOrder]";
    DELETE_RETURN_URL = "ssr/v2/archived-return/";
    MOVE_TO_DELIVERED_URL = "ssr/v2/archived-return/move-to-delivered";
    RECALL_RETURN_URL = "ssr/v2/archived-return/recall";
    RESEND_ACCESS_LINK_URL = "ssr/v2/archived-return/resend-access-link";
    SEND_REMINDER_URL = "ssr/v2/archived-return/send-reminder";
    SIGNATURE_STATUS_URL = "ssr/v2/archived-return/{taxReturnId}/signature-status";
    SIGNER_INFORMATION_URL = "ssr/v2/archived-return/{taxReturnId}/signer-info";
}
